import type { SchemaViewerFieldExpressionWrapperProps } from "./schema-viewer-field-expression.type";

import { SchemaViewerFieldExpression } from "./schema-viewer-field-expression.component";
import { SCHEMA_VIEWER_EXPRESSION_FALLBACK_VALUE } from "./schema-viewer-field-expression.constant";

export const SchemaViewerFieldExpressionWrapper = ({
  schema,
  form,
}: SchemaViewerFieldExpressionWrapperProps) => {
  if (!form) return SCHEMA_VIEWER_EXPRESSION_FALLBACK_VALUE;

  return <SchemaViewerFieldExpression schema={schema} form={form} />;
};
